import { cloneDeep } from "@/js/utils"
import router from '@/router'

const DEFAULT_SETTINGS = {
	lang: 'fr',
	sounds: {
		volume: 5,
		muted: false,
	},
	musics: {
		volume: 3,
		muted: false,
	},
	voices: {
		volume: 5,
		muted: false,
	}
}
export const useAppStore = defineStore({
	id: 'app',

	state: () => ({
		ready: false,
		loading: false,
		device: 'desktop',
		modals: [],
		notifications: [],
		setUpClient: null,
		mainSection: null,
		settings: cloneDeep(DEFAULT_SETTINGS),
		hasSeenTeacherPanelAnimation: true,
		hintBubbleVisible: false,
		isGameMenuOpen: false,
	}),
	
	actions: {
		applyVolumeSettings(settings) {
			const sounds = settings?.sounds ?? { volume: 0 }
			const musics = settings?.musics ?? { volume: 0 }
			const soundVolume = sounds.muted ? 0 : sounds.volume ?? 0
			const musicVolume = musics.muted ? 0 : musics.volume ?? 0

			changeSoundsVolume({ volume: soundVolume / 10 })
			changeMusicsVolume({ volume: musicVolume / 10 })
		},
		async initApp() {
			try {
				this.loadSettings()
				await initMusics()
				initSounds()

				this.applyVolumeSettings(this.settings)
	
				await Promise.all([
					loadMedias(),
					this.loadSetUpClient()
				])
			} catch(err) {
				console.error(err)
			} finally {
				this.ready = true
			}
		},
		resetSettings() {
			localStorage?.removeItem?.('settings')
			this.settings = cloneDeep(DEFAULT_SETTINGS)
		},
		// To avoid losing the legacy version of the settings. Verifies if legacy settings exist and migrates them.
		loadSettings() {
			let settings = parseJson(localStorage.getItem('settings')) ?? this.settings

			if (settings.musics) {
				this.settings = settings
			} else {
				settings = {
					...this.settings,
					...settings,
				}
	
				if (isValue(settings.volumeSounds)) settings.sounds.volume = settings.volumeSounds
				if (isValue(settings.volumeMusics)) settings.musics.volume = settings.volumeMusics
				if (isValue(settings.volumeVoices)) settings.voices.volume = settings.volumeVoices
	
				delete settings.volumeSounds
				delete settings.volumeMusics
				delete settings.volumeVoices
	
				this.settings = settings
			}
		},

		setMainSection(mainSection){
			this.mainSection = mainSection
		},

		async loadMainSectionIfNull() {
			this.loading = true
			this.mainSection = this.mainSection ?? await mainSection()
			this.loading = false
		},

		async loadSetUpClient(){
			this.setUpClient = await setUpClient()
		},

		setGameMenuOpen(value) {
			this.isGameMenuOpen = value
			if (value) this.hideHintBubble()
		},
		showHintBubble() {
			if (this.isGameMenuOpen) return

			const name = router.currentRoute.value?.name
			const isCityMap = name === 'city'
			if (!isCityMap) return

			this.hintBubbleVisible = true
		},
		hideHintBubble() {
			this.hintBubbleVisible = false
		},

		setRatio({ width, height }) {
			if (width < 600) this.device = 'mobile'
			else if (width < 900 || height < 830) this.device = 'tablet-vertical'
			else if (width < 1200) this.device = 'tablet-horizontal'
			else this.device = 'desktop'
		},

		addModal(data) {
			if (data.slug) {
				this.modals.push({ 
					...data, 
					id: getRandomID(), 
					on: {
						...(data?.on ?? {}),
						close: () => this.removeModal({ id: data.id }),
					}
				})
			}
		},

		removeModal({ id }) {
			this.modals = this.modals.filter(n => n.id !== id)
		},

		removeAllModals() {
			this.modals = []
		},
	},

})


if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot))
}